import React, {Fragment, FunctionComponent} from 'react'
import {Review} from '@App/types'
import {useDates} from "@App/hooks/useDates";
import {Transition} from "@headlessui/react";

type ReviewItemProps = {
    review: Review
}

export const ReviewItem: FunctionComponent<ReviewItemProps> = (props: ReviewItemProps) => {

    const {formatDate} = useDates()

    return (
        <Transition
            appear={true}
            show={true}
            enter={"transition transform duration-300 ease-out"}
            enterFrom={"translate-x-4 opacity-0"}
            enterTo={"translate-x-0 opacity-100"}
            leave={"transition transform duration-300 ease-in"}
            leaveFrom={"opacity-100"}
            leaveTo={"opacity-0"}>
            <div className="mb-10">
                <div className="flex items-center mb-1">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 mr-1" width="17" height="16"
                         viewBox="0 0 17 16">
                        <path fill="#E8B12E" fillRule="evenodd"
                              d="M13.01 10.236l3.854-3.714a.44.44 0 0 0 .114-.456.45.45 0 0 0-.365-.302l-5.326-.766L8.906.228C8.83.076 8.665 0 8.5 0c-.165 0-.33.076-.406.228l-2.382 4.77-5.325.766a.441.441 0 1 0-.25.758l3.853 3.714-.91 5.244a.442.442 0 0 0 .301.495c.015.005.03.006.045.01a.436.436 0 0 0 .163.008c.012-.002.024-.002.036-.005a.467.467 0 0 0 .112-.04L8.5 13.474l4.763 2.476a.457.457 0 0 0 .476-.034c.14-.1.21-.268.18-.435l-.91-5.244z"/>
                    </svg>
                    {((props.review.rating / 100) * 5).toFixed(2).replace('.', ',')}
                    <div className="font-bold ml-3">{props.review.author}</div>
                </div>

                <div
                    className="italic text-xs mb-3">{formatDate(new Date(props.review.published_at), 'dd.MM.yy')}
                    {props.review.vendor_name && (
                        <Fragment>
                            • von {props.review.vendor_name}
                        </Fragment>
                    )}
                </div>
                <p>
                    {props.review.comment}
                </p>
            </div>
        </Transition>
    )
}
